var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 10,
    fill: "#DB0011",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24.803 12.019-10.78 1.527A1.196 1.196 0 0 0 13 14.725v20.753c0 .588.44 1.094 1.024 1.178l10.78 1.527c.967.16 1.924-.665 1.9-1.65V13.67c.022-.984-.93-1.808-1.9-1.65zm.39 24.694a.23.23 0 0 1-.19.056l-10.575-1.497V14.93L25 13.433c.168-.014.255.078.272.235v7.85l-1.878.267a1.194 1.194 0 0 0-1.023 1.177v1.423h-1.448c-.938.016-.939 1.412 0 1.428h1.448v1.423c0 .588.44 1.095 1.023 1.178l1.878.265v7.851a.23.23 0 0 1-.082.18zm.081-9.474-1.473-.208v-1.216h-.006a.713.713 0 1 0 0-1.428h.006v-1.216l1.473-.209zm3.568-12.509h3.728v3.876c.015.937 1.412.94 1.428 0v-4.113a1.19 1.19 0 0 0-1.19-1.19h-3.965c-.937.016-.94 1.412 0 1.428zm4.442 16.154a.713.713 0 0 0-.714.713v3.876h-3.728a.713.713 0 1 0 0 1.427h3.966a1.19 1.19 0 0 0 1.19-1.19v-4.113a.713.713 0 0 0-.714-.713m-4.84-6.586 2.912-3.186c.683-.803 2.106-.253 2.068.803v1.045h2.386c.657 0 1.19.533 1.19 1.19v1.904a1.19 1.19 0 0 1-1.19 1.19h-2.386v1.045c.036 1.052-1.38 1.61-2.07.802l-2.911-3.187a1.184 1.184 0 0 1 0-1.606m3.551 3.378v-.67c0-.656.534-1.19 1.19-1.19h2.386v-1.428h-2.386a1.19 1.19 0 0 1-1.19-1.19v-.669l-2.352 2.574z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUndo);
export default __webpack_public_path__ + "static/media/ic_undo.2c78b52fa8c328b457a25832b962b133.svg";
export { ForwardRef as ReactComponent };